export default "__VITE_ASSET__CC0I4keW__"